import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/raleway/400.css'
import '@fontsource/playfair-display/400.css'
import Main from './main'
import { ChakraProvider } from '@chakra-ui/react'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <Main />
    </ChakraProvider>
  </React.StrictMode>
);

